import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

/**
 * useMediaQuery abstraction for breakpoints.
 * @see useMediaQuery
 */
export const useBreakpoint = (direction: 'up' | 'down', breakpoint: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints[direction](breakpoint));
};
